<template>
	<div :class="[$t('common.fontFamily'), $t('common.lang'), $t('common.type')]">
		<page-navigate></page-navigate>

		<section class="fca1">
			<h1 :class="[$t('common.fontFamilyTitle')]" v-html="$t('FCA.FCA流动性清算账户开设流程')">
			</h1>
		</section>
		<section class="fca2">
			<img src="../assets/image/FCA/logo1.png" alt="" class="logo-img1 pc" />
			<img src="../assets/image/FCA/logo1_m.png" alt="" class="logo-img1 mobile" />
			<div class="fca2-content">
				<p v-html="$t('FCA.EBC Financial Group Limited是受英国金融市场行为管理局（FCA）授权并监管的综合金融券商')">

				</p>
				<p>
					{{ $t('FCA.在EBC Financial Group Limited开设FCA流动性清算账户') }}
				</p>
			</div>
		</section>
		<section class="fca3">
			<img src="../assets/image/FCA/logo2.png" alt="" class="logo-img2 pc" />
			<img src="../assets/image/FCA/logo2_m.png" alt="" class="logo-img2 mobile" />
			<div class="fca2-content">
				<p>
					{{ $t('FCA.欧盟《金融工具市场法规（MiFID）》及其后修订版MiFID') }}
				</p>
				<p>
					{{ $t('FCA.根据FCA法规') }}
				</p>
			</div>
		</section>
		<section class="fca4">
			<h2 :class="[$t('common.fontFamilyTitle')]" v-html="$t('FCA.专业投资者须满足以下三个标准中的其中两个')">
			</h2>
			<div class="title-line"></div>
			<div class="fca4-content">
				<div class="fca4-item">
					<img src="../assets/image/FCA/icon1.svg" alt="" class="fca4-item-img" />
					<div class="fca4-item-text">{{ $t('FCA.过去一年平均交易频率达到10次/季度') }}</div>
				</div>
				<div class="fca4-item">
					<img src="../assets/image/FCA/icon2.svg" alt="" class="fca4-item-img" />
					<div class="fca4-item-text">
						{{ $t('FCA.持有超过50万欧元的投资组合') }}
					</div>
				</div>
				<div class="fca4-item">
					<img src="../assets/image/FCA/icon3.svg" alt="" class="fca4-item-img" />
					<div class="fca4-item-text">
						{{ $t('FCA.在金融行业工作或至少工作过一年') }}
					</div>
				</div>
			</div>
		</section>
		<section class="fca5">
			<h2 :class="[$t('common.fontFamilyTitle')]" v-html="$t('FCA.FCA流动性清算账户开户流程')">
			</h2>
			<div class="title-line"></div>
			<div class="fca5-content">
				<div class="fca5-item">
					<img src="../assets/image/FCA/step1.svg" alt="" class="fca5-item-img" />
					<p class="p1 " :class="[$t('common.fontFamilyTitle')]">{{ $t('FCA.获取申请表') }}</p>
					<p class="p2">{{ $t('FCA.访EBC英国站') }}</p>
				</div>
				<div class="fca5-item">
					<img src="../assets/image/FCA/step2.svg" alt="" class="fca5-item-img" />
					<p class="p1 " :class="[$t('common.fontFamilyTitle')]">{{ $t('FCA.提交材料') }}</p>
					<p class="p2">{{ $t('FCA.按要求填写') }}</p>
				</div>
				<div class="fca5-item">
					<img src="../assets/image/FCA/step3.svg" alt="" class="fca5-item-img" />
					<p class="p1 " :class="[$t('common.fontFamilyTitle')]">{{ $t('FCA.合规审核') }}</p>
					<p class="p2">{{ $t('FCA.等待合规审核') }}</p>
				</div>
				<div class="fca5-item">
					<img src="../assets/image/FCA/step4.svg" alt="" class="fca5-item-img" />
					<p class="p1 " :class="[$t('common.fontFamilyTitle')]">{{ $t('FCA.开户成功') }}</p>
					<p class="p2">{{ $t('FCA.登录并设置您的FCA账户') }}</p>
				</div>
			</div>
			<a href="https://ebcfin.co.uk/" class="btn btn-white" target="_blank">
				{{ $t('FCA.获取申请表') }}
			</a>
		</section>
		<section class="fca6">
			<h2 :class="[$t('common.fontFamilyTitle')]" v-html="$t('FCA.最权威的监管保护和最安全的')">

			</h2>
			<div class="title-line"></div>
			<img class="fca6-img pc" :src="imgPath" alt="" />
			<img class="fca6-img mobile" :src="img_m_Path" alt="" />
			<div class="fca6-content">
				<p class="p1 " :class="[$t('common.fontFamilyTitle')]">
					{{ $t('FCA.英国金融市场行为管理局（FCA）') }}
				</p>
				<p class="p2" v-html="$t('FCA.FCA流动性清算账户咨询邮箱')">
				</p>
			</div>
		</section>

		<ss-contact-us-new mode="all"></ss-contact-us-new>
		<page-footer></page-footer>
	</div>
</template>

<script>
export default {
	data() {
		return {
			imgPath: this.$t('common.requestLang') == 'zh_CN' ? require('../assets/image/FCA/fca6.png') : require('../assets/image/FCA/fca6_en.png'),
			img_m_Path: this.$t('common.requestLang') == 'zh_CN' ? require('../assets/image/FCA/fca6-m.png') : require('../assets/image/FCA/fca6-m_en.png')
		}
	}
}
</script>

<style lang="scss" scoped>
a,
a:visited,
a:active {
  text-decoration: none;
}

a::before {
  content: none;
}
.fca1 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 120rem;
  height: 333rem;
  background: url(../assets/image/FCA/bg1.jpg);
  background-size: cover;
  background-repeat: no-repeat;
}
.fca1 h1 {
  color: #fff;
  font-size: 40rem;
  font-style: normal;
  font-weight: 900;
  line-height: 1em;
}
.fca1 h1 .fca {
  font-family: "Financier Display";
  font-size: 52rem;
  line-height: 1em;
}
.fca2 {
  display: flex;
  align-items: center;
  padding: 120rem 270rem;
  justify-content: space-between;
}
.fca2 .logo-img1 {
  width: 360rem;
  height: 74rem;
}

.fca2-content {
  max-width: 720rem;
  color: #666;
  font-size: 16rem;
  font-style: normal;
  font-weight: 400;
  line-height: 33rem; /* 206.25% */
}
.fca2-content p + p {
  margin-top: 10rem;
}

.fca3 {
  display: flex;
  align-items: center;
  padding: 120rem 270rem;
  justify-content: space-between;
  background: linear-gradient(
    90deg,
    rgba(246, 246, 246, 0.5) 0%,
    rgba(217, 217, 217, 0) 100%
  );
}
.fca3 .logo-img2 {
  width: 538rem;
  height: 74rem;
}

.fca3-content {
  max-width: 460rem;
  color: #666;
  font-size: 16rem;
  font-style: normal;
  font-weight: 400;
  line-height: 33rem; /* 206.25% */
}
.fca3-content p + p {
  margin-top: 10rem;
}
.fca4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120rem 270rem;
}
.title-line {
  margin: 50rem auto 110rem;
  width: 100rem;
  height: 2px;
  background-color: #a52933;
}
.fca6 h2,
.fca5 h2,
.fca4 h2 {
  margin: 0 auto;
  max-width: 1000rem;
  color: #a52933;
  text-align: center;
  font-size: 36px;
  font-weight: 900;
  line-height: normal;
}
.fca4-content {
  display: flex;
  justify-content: space-around;
  gap: 75rem;
}
.fca4-item {
  flex-shrink: 0;
  display: flex;
  gap: 25rem;
  align-items: center;
}
.fca4-item-img {
  width: 102rem;
  height: 102rem;
}
.fca4-item-text {
  max-width: 216rem;
  color: #666;
  font-size: 16rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal; /* 175% */
}
.en .fca4-item-text{
  max-width: 274rem; 
}

.fca5 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120rem 270rem;
  background: linear-gradient(
    90deg,
    rgba(246, 246, 246, 0.5) 0%,
    rgba(217, 217, 217, 0) 100%
  );
}

.fca5-content {
  display: flex;
  justify-content: space-between;
  gap: 45rem;
  margin-bottom: 110rem;
}

.fca5-item {
  width: 284rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fca5-item-img {
  width: 68rem;
  height: 68rem;
  margin-bottom: 25rem;
}

.fca5-item .p1 {
  color: #000;
  text-align: center;
  font-size: 24rem;
  font-weight: 700;
  line-height: 28rem;
}
.vi-font-family .fca5-item .p1,
.th-font-family .fca5-item .p1,
.en-font-family .fca5-item .p1{
  min-height: 56rem;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.fca5-item .p2 {
  margin-top: 6rem;
  color: #666;
  text-align: center;
  font-size: 16rem;
  font-weight: 400;
  line-height: normal;
}

.btn {
  padding: 12rem 20rem;
  display: flex;
  min-width: 190rem;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #a52933;
  font-size: 18rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  border: 1px solid #a52933;
  border-radius: 2rem;
  transition: all 0.3s;
}
.btn:hover {
  color: #fff;
  background-color: #a52933;
}

.fca6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120rem 270rem;
}
.fca6-img {
  width: 1180rem;
}
.fca6-content {
  padding-left: 242rem;
}

.fca6-content .p1 {
  margin-top: 30rem;
  color: #000;
  text-align: center;
  font-size: 18rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
}
.fca6-content .p2 {
  margin-top: 16rem;
  color: #666;
  text-align: center;
  font-size: 16rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
::v-deep .fca6-content .p2 a {
  color: #666;
}

@media (max-width: 996px) {
  .fca1 {
    background-position: right;
    padding: 0 80rem;
  }
  .fca1 h1 {
    text-align: center;
  }

  .fca3,
  .fca2 {
    padding: 100rem 40rem;
    flex-direction: column;
    gap: 100rem;
  }
  .fca2-content {
    max-width: unset;
    font-size: 24rem;
    padding: 0 50rem;
    line-height: normal;
  }
  .fca2 .logo-img1,
  .fca3 .logo-img2 {
    width: 561rem;
    height: 89rem;
  }
  .fca5,
  .fca6,
  .fca4 {
    padding: 100rem 40rem;
  }

  .fca6 h2,
  .fca5 h2,
  .fca4 h2 {
    font-size: 44rem;
    line-height: normal;
  }

  .title-line {
    margin: 40rem auto 80rem;
  }

  .fca4-content {
    flex-direction: column;
  }
  .en .fca4-item-text,
  .fca4-item-text {
    max-width: unset;
    width: 370rem;
    font-size: 24rem;
    line-height: normal;
    gap: 70rem;
  }
  

  .fca5-content {
    padding: 0 25rem;
    flex-wrap: wrap;
    gap: 95rem 0;
  }
  .fca5-item .p1{
    font-size: 26rem;
    text-align: center;
  }
  .fca5-item .p2{
    text-align: center;
    margin-top: 10rem;
    font-size: 20rem;
  }

  .fca6-img{
    width: 484rem;
  }
  .fca6-content{
    padding-left: 0;
  }
  .fca6-content .p1{
    margin-top: 50rem;
    font-size: 24rem;
  }
  .fca6-content .p2{
    font-size: 22rem;
  }
  .btn{
    font-size: 24rem;
    padding: 14rem 20rem;
    min-width: 310rem;
  }
}
</style>
